export enum SocialPlatform {
  Apple = 'Apple',
  Facebook = 'Facebook',
  Google = 'Google',
  LinkedIn = 'Linkedin',
}
